/* unplugin-vue-components disabled */import { render } from "./TopHeader.vue?vue&type=template&id=72841848&ts=true"
import script from "./TopHeader.vue?vue&type=script&lang=ts"
export * from "./TopHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/yanan/Downloads/github/Yanan-Wang-cs.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__